module.exports = __webpack_public_path__ + "img/ComfyUI.7074271c.svg";